import {Model} from "@/app/Model";
import {Utils} from "@/app/Utils";
import {FamigliaData} from "@/app/data/FamigliaData";
import {TestoResult} from "./data/TestoResult";
import {TestoData} from "@/app/data/TestoData";
import {FamigliaAdminComms} from "@/app/admin/FamigliaAdminComms";

import {Comms} from "@/app/Comms";

declare let frontendConfig: any;
declare let gtagO: Function;

export class CommsFamiglia {

    public comms: Comms = Comms.getInstance();

    protected static instance: CommsFamiglia;
    static listAllDone: boolean = false;

    public continueFunction: Function | null = null;

    protected inChiamataCitta: boolean = false;
    protected inChiamataGiudici: boolean = false;
    protected inChiamataDashboard: boolean = false;
    protected inChiamataPercorso: boolean = false;
    protected inChiamataDejure: boolean = false;

    public famigliaAdmin: FamigliaAdminComms = FamigliaAdminComms.getInstance();

    public static getInstance(): CommsFamiglia {
        if (!CommsFamiglia.instance) {
            CommsFamiglia.instance = new CommsFamiglia();
        }

        return CommsFamiglia.instance;
    }

    public setup(): void {
        this.famigliaAdmin.commsFamiglia = this;

        setTimeout( ()=> {
            Model.fam_setupped = true;
        }, 1000)
    }
    
    //BUSINESS
    //setup lists
    public listAll(callback: Function | null = null): void {
        this.listCitta((e: IEsito) => {
            this.listGiudici((e: IEsito) => {
                CommsFamiglia.listAllDone = true;

                setTimeout( ()=> {postMessage("listAllRefresh")}, 2000);

                if (callback) callback();
            })
        })
    }

    public listCitta(callback: Function | null = null): void {
        if (Comms.hf_isNotLogged()) {
            this.continueFunction = this.listCitta;
            setTimeout(function () {
                Comms.getInstance().doLoginByToken(callback);
            }, Comms.baseLoadTimeout);
            return;
        } else {
            this.continueFunction = null;
        }

        let model: Model = Model.getReactiveInstance();

        if (!this.inChiamataCitta) {
            this.inChiamataCitta = true;

            model.fam_lista_citta = [];

            let commander: string = "fam_listCitta";
            let endpoint: string = "/graphql";
            let payload = {
                query: `{
                    pgQuery(
                         input: {
                            name: "fam_lista_citta"
                            params: { }
                         }
                    ) {
                         list
                         record
                    }
                }`,
                variables: {},
                operationName: null,
            };
            let options = {
                method: "POST",
                headers: {
                    accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            };

            //@ts-ignore
            if (Comms.baseUrl == "") options.headers["x-user"] = model.user.jwt;

            let errorCallback: Function = (): void => { };
            let innerCallback: Function = (esito: IEsito): void => {
                Utils.successAlert(esito);
                this.inChiamataCitta = false;
                if (esito.response && esito.response.data && esito.response.data.pgQuery && esito.response.data.pgQuery.list) {
                    model.fam_lista_citta = esito.response.data.pgQuery.list;
                }
                if (callback) callback(esito);
            };

            this.comms.doFetch(endpoint, options, commander, innerCallback, errorCallback);
        }
    }

    public listGiudici(callback: Function | null = null): void {
        if (Comms.hf_isNotLogged()) {
            this.continueFunction = this.listGiudici;
            setTimeout(function () {
                Comms.getInstance().doLoginByToken(callback);
            }, Comms.baseLoadTimeout);
            return;
        } else {
            this.continueFunction = null;
        }

        let model: Model = Model.getReactiveInstance();

        if (!this.inChiamataGiudici) {
            this.inChiamataGiudici = true;

            model.fam_lista_giudici = [];

            let commander: string = "fam_listGiudici";
            let endpoint: string = "/graphql";
            let payload = {
                query: `{
                    pgQuery(
                         input: {
                            name: "fam_lista_giudici"
                            params: { }
                         }
                    ) {
                         list
                         record
                    }
                }`,
                variables: {},
                operationName: null,
            };
            let options = {
                method: "POST",
                headers: {
                    accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            };

            //@ts-ignore
            if (Comms.baseUrl == "") options.headers["x-user"] = model.user.jwt;

            let errorCallback: Function = (): void => { };
            let innerCallback: Function = (esito: IEsito): void => {
                Utils.successAlert(esito);
                this.inChiamataGiudici = false;
                if (esito.response && esito.response.data && esito.response.data.pgQuery && esito.response.data.pgQuery.list) {
                    model.fam_lista_giudici = esito.response.data.pgQuery.list;
                }
                if (callback) callback(esito);
            };

            this.comms.doFetch(endpoint, options, commander, innerCallback, errorCallback);
        }
    }

    //query dashboard
    public queryDashboard(callback: Function | null = null, soloPaginazione: boolean = false): void {
        if (Comms.hf_isNotLogged()) {
            this.continueFunction = this.queryDashboard;

            setTimeout(function () {
                Comms.getInstance().doLoginByToken(callback);
            }, Comms.baseLoadTimeout);
            return;
        } else {
            this.continueFunction = null;
        }

        let model: Model = Model.getReactiveInstance();

        if (!this.inChiamataDashboard) {
            this.inChiamataDashboard = true;

            if (!soloPaginazione) {
                model.fam_get_dashboard = new FamigliaData();
            }

            let commander: string = "queryDashboard";
            let endpoint: string = "/graphql";
            let innerParams: string = "";

            if (model.fam_flow_dashboard.durata_del_processo_active)  {
                innerParams += 'durata_procedimento:' + model.fam_flow_dashboard.durata_del_processo + ' ';
            }
            if (model.fam_flow_dashboard.durata_del_processo_notNull === true) {
                innerParams += 'durata_procedimento_not_null: "true" ';
            } else {
                innerParams += 'durata_procedimento_not_null: "false" ';
            }
            if (model.fam_flow_dashboard.riferimento_normativo != "" && model.fam_flow_dashboard.riferimento_normativo != " ")  {
                innerParams += 'riferimento_normativo:["' + model.fam_flow_dashboard.riferimento_normativo.replace(/'/g, "''") + '"] ';
            }
            if (model.fam_flow_dashboard.tipologia_procedimento != "")  {
                innerParams += 'tipologia_procedimento:"' + model.fam_flow_dashboard.tipologia_procedimento.replace(/'/g, "''") + '" ';
            }
            if (model.fam_flow_dashboard.oggetto_di_giudizio != "")  {
                innerParams += 'oggetto_di_giudizio:"' + model.fam_flow_dashboard.oggetto_di_giudizio.replace(/'/g, "''") + '" ';
            }
            if (model.fam_flow_dashboard.addebito == "Si") {
                innerParams += 'addebito: true ';
            } else if (model.fam_flow_dashboard.addebito == "No") {
                innerParams += 'addebito: false ';
            }
            if (model.fam_flow_dashboard.motivi_addebito_separazione != "" && model.fam_flow_dashboard.motivi_addebito_separazione != " ")  {
                innerParams += 'motivi_addebito_separazione:["' + model.fam_flow_dashboard.motivi_addebito_separazione.replace(/'/g, "''") + '"] ';
            }
            if (model.fam_flow_dashboard.regime_mantenimento != "")  {
                innerParams += 'regime_mantenimento:"' + model.fam_flow_dashboard.regime_mantenimento.replace(/'/g, "''") + '" ';
            }
            if (model.fam_flow_dashboard.valore_assegno_mantenimento_active)  {
                innerParams += 'assegno_mantenimento_da:' + model.fam_flow_dashboard.valore_assegno_mantenimento_da + ' ';
                innerParams += 'assegno_mantenimento_a:' + model.fam_flow_dashboard.valore_assegno_mantenimento_a + ' ';
            }
            if (model.fam_flow_dashboard.valore_assegno_contributo_mantenimento_active)  {
                innerParams += 'assegno_contributo_mantenimento_da:' + model.fam_flow_dashboard.valore_assegno_contributo_mantenimento_da + ' ';
                innerParams += 'assegno_contributo_mantenimento_a:' + model.fam_flow_dashboard.valore_assegno_contributo_mantenimento_a + ' ';
            }
            if (model.fam_flow_dashboard.valore_assegno_divorzile_active)  {
                innerParams += 'assegno_divorzile_da:' + model.fam_flow_dashboard.valore_assegno_divorzile_da + ' ';
                innerParams += 'assegno_divorzile_a:' + model.fam_flow_dashboard.valore_assegno_divorzile_a + ' ';
            }
            if (model.fam_flow_dashboard.regime_affidamento != "")  {
                innerParams += 'regime_affidamento:"' + model.fam_flow_dashboard.regime_affidamento.replace(/'/g, "''") + '" ';
            }
            if (model.fam_flow_dashboard.assegnazione_casa_familiare != "")  {
                innerParams += 'assegnazione_casa_familiare:"' + model.fam_flow_dashboard.assegnazione_casa_familiare.replace(/'/g, "''") + '" ';
            }
            if (model.fam_flow_dashboard.regime_collocamento != "")  {
                innerParams += 'regime_collocamento:"' + model.fam_flow_dashboard.regime_collocamento.replace(/'/g, "''") + '" ';
            }
            if (model.fam_flow_dashboard.id_localita != "")  {
                innerParams += 'id_localita:"' + model.fam_flow_dashboard.id_localita.replace(/'/g, "''") + '" ';
            }
            if (model.fam_flow_dashboard.giudice != "")  {
                innerParams += 'giudice:["' + model.fam_flow_dashboard.giudice.replace(/'/g, "''") + '"] ';
            }
            if (model.fam_flow_dashboard.data_active)  {
                let dataDa: Date = new Date(model.fam_flow_dashboard.data_da + "-1-1");
                dataDa.setHours(0,0,0, 0);

                let dataA: Date = new Date(model.fam_flow_dashboard.data_a + "-12-31");
                dataA.setHours(23,59,59, 999);

                let dataDaIso: string = dataDa.toISOString();
                let dataDaIsoSpl: string[] = dataDaIso.split("T");
                let dataAIso: string = dataA.toISOString();
                let dataAIsoSpl: string[] = dataAIso.split("T");

                innerParams += 'data_da:"' + dataDaIsoSpl[0] + '" ';
                innerParams += 'data_a:"' + dataAIsoSpl[0] + '" ';
            }

            if (model.fam_flow_dashboard.paginazione_start > 0) {
                innerParams += 'start:' + Math.floor(model.fam_flow_dashboard.paginazione_start * model.fam_flow_dashboard.paginazione_rows).toFixed(0) + ' ';
            }

            let params: string = `{ ${innerParams} }`;

            let payload = {
                query: `{
                  pgQuery(
                     input: {
                        name: "civ_famiglia_get_dashboard"
                        params: ${params}
                     }
                  ) {
                     list
                  }
               }`,
                variables: {},
                operationName: null,
            };

            let options = {
                method: "POST",
                headers: {
                    accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            };

            //@ts-ignore
            if (Comms.baseUrl == "") options.headers["x-user"] = model.user.jwt;

            let errorCallback: Function = (): void => { };
            
            let innerCallback: Function = (esito: IEsito): void => {
                Utils.successAlert(esito);
                this.inChiamataDashboard = false;

                if (soloPaginazione) {
                    let useJson: any = esito.response.data.pgQuery.list[0].result;

                    if (useJson["sentenze_paginate"]) {
                        model.fam_get_dashboard.sentenze_paginate = useJson["sentenze_paginate"]; //aggiorno solo dati relativi a paginazione in model.fam_get_dashboard
                    }
                    if (useJson["sentenze_paginate_jump"]) {
                        model.fam_get_dashboard.sentenze_paginate_jump = useJson["sentenze_paginate_jump"];
                        model.fam_get_dashboard.sentenze_paginate_jump_display = model.fam_get_dashboard.sentenze_paginate_jump.slice(0, model.fam_flow_dashboard.diritto_paginazione_rows);
                    }
                    model.fam_flow_dashboard.diritto_paginazione_start = 0;
                    model.fam_flow_dashboard.diritto_paginazione_tot = model.fam_get_dashboard.sentenze_paginate_jump.length;
                    model.fam_flow_dashboard.diritto_paginazione_pages = Math.ceil(model.fam_flow_dashboard.diritto_paginazione_tot / model.fam_flow_dashboard.diritto_paginazione_rows) -1;
                } else {
                    model.fam_get_dashboard = new FamigliaData(esito.response);
                }

                // gtagO({
                //     'event': 'ricerca', 
                //     'tipoRicerca': 'ricerca generale famiglia', 
                //     'testoCercato': JSON.stringify(payload), 
                //     'risultati': model.fam_get_dashboard.totale_numero_sentenze.valore
                // });

                if (callback) callback(esito);
            };

            this.comms.doFetch(endpoint, options, commander, innerCallback, errorCallback);
        }
    }
    public queryPercorso(callback: Function | null = null, soloPaginazione: boolean = false): void {
        if (Comms.hf_isNotLogged()) {
            this.continueFunction = this.queryPercorso;

            setTimeout(function () {
                Comms.getInstance().doLoginByToken(callback);
            }, Comms.baseLoadTimeout);
            return;
        } else {
            this.continueFunction = null;
        }

        let model: Model = Model.getReactiveInstance();

        if (!this.inChiamataPercorso) {
            this.inChiamataPercorso = true;

            if (!soloPaginazione) {
                model.fam_get_percorso = new FamigliaData();
            }

            let commander: string = "queryPercorso";
            let endpoint: string = "/graphql";
            let innerParams: string = "";
            let innerGrafici: number[] = [];

            if (model.fam_flow_percorso.oggetto_di_giudizio != "")  {
                innerParams += 'oggetto_di_giudizio:"' + model.fam_flow_percorso.oggetto_di_giudizio.replace(/'/g, "''") + '" ';
            }
            innerGrafici.push(3);
            if (model.fam_flow_percorso.tipologia_procedimento != "")  {
                innerParams += 'tipologia_procedimento:"' + model.fam_flow_percorso.tipologia_procedimento.replace(/'/g, "''") + '" ';
            }
            innerGrafici.push(4);
            innerGrafici.push(5);
            innerGrafici.push(6);
            if (model.fam_flow_percorso.addebito == "Si") {
                innerParams += 'addebito: true ';

            } else if (model.fam_flow_percorso.addebito == "No") {
                innerParams += 'addebito: false ';
            }
            if (model.fam_flow_percorso.motivi_addebito_separazione != "" && model.fam_flow_percorso.motivi_addebito_separazione != " ")  {
                innerParams += 'motivi_addebito_separazione:["' + model.fam_flow_percorso.motivi_addebito_separazione.replace(/'/g, "''") + '"] ';
            }
            if (model.fam_flow_percorso.figli) {
                innerGrafici.push(8);
                innerGrafici.push(7);
                innerGrafici.push(10);
            }
            if (model.fam_flow_percorso.regime_affidamento != "")  {
                innerParams += 'regime_affidamento:"' + model.fam_flow_percorso.regime_affidamento.replace(/'/g, "''") + '" ';

            }
            if (model.fam_flow_percorso.regime_mantenimento != "")  {
                innerParams += 'regime_mantenimento:"' + model.fam_flow_percorso.regime_mantenimento.replace(/'/g, "''") + '" ';

            }
            if (model.fam_flow_percorso.regime_collocamento != "")  {
                innerParams += 'regime_collocamento:"' + model.fam_flow_percorso.regime_collocamento.replace(/'/g, "''") + '" ';

            }
            if (model.fam_flow_percorso.paginazione_start > 0) {
                innerParams += 'start:' + Math.floor(model.fam_flow_percorso.paginazione_start * model.fam_flow_percorso.paginazione_rows).toFixed(0) + ' ';
            }

            innerParams += 'durata_procedimento_not_null: "false" ';

            if (innerGrafici.length > 0) {
                if (innerGrafici.indexOf(1)<0) {
                    innerGrafici.push(1);
                }
                if (innerGrafici.indexOf(17)<0) {
                    innerGrafici.push(17);
                }
                innerParams += 'grafico:[' + innerGrafici.join(",") + ']';
            }
            let params: string = `{ ${innerParams} }`;

            let payload = {
                query: `{
                  pgQuery(
                     input: {
                        name: "civ_famiglia_get_dashboard"
                        params: ${params}
                     }
                  ) {
                     list
                  }
               }`,
                variables: {},
                operationName: null,
            };

            let options = {
                method: "POST",
                headers: {
                    accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            };

            //@ts-ignore
            if (Comms.baseUrl == "") options.headers["x-user"] = model.user.jwt;

            let errorCallback: Function = (): void => { };

            let innerCallback: Function = (esito: IEsito): void => {
                Utils.successAlert(esito);
                this.inChiamataPercorso = false;

                if (esito.response.errors && esito.response.errors.length > 0) {
                    alert("ERRORE DEL SERVER NELLA RICERCA PERCORSO.\nSiete pregati di riprovare piu tardi.\n\n"+esito.response.errors[0].message);
                    console.log("ERROR", esito.response.errors[0].message);
                }

                if (soloPaginazione) {
                    let useJson: any = esito.response.data.pgQuery.list[0].result;

                    if (useJson["sentenze_paginate"]) {
                        model.fam_get_percorso.sentenze_paginate = useJson["sentenze_paginate"]; //aggiorno solo dati relativi a paginazione in model.fam_get_percorso
                    }
                    if (useJson["sentenze_paginate_jump"]) {
                        model.fam_get_percorso.sentenze_paginate_jump = useJson["sentenze_paginate_jump"];
                        model.fam_get_percorso.sentenze_paginate_jump_display = model.fam_get_percorso.sentenze_paginate_jump.slice(0, model.fam_flow_percorso.diritto_paginazione_rows);
                    }
                    model.fam_flow_percorso.diritto_paginazione_start = 0;
                    model.fam_flow_percorso.diritto_paginazione_tot = model.fam_get_percorso.sentenze_paginate_jump.length;
                    model.fam_flow_percorso.diritto_paginazione_pages = Math.ceil(model.fam_flow_percorso.diritto_paginazione_tot / model.fam_flow_percorso.diritto_paginazione_rows) -1;
                } else {
                    model.fam_get_percorso = new FamigliaData(esito.response);
                }

                // gtagO({
                //     'event': 'ricerca', 
                //     'tipoRicerca': 'ricerca generale famiglia', 
                //     'testoCercato': JSON.stringify(payload), 
                //     'risultati': model.fam_get_percorso.totale_numero_sentenze.valore
                // });

                if (callback) callback(esito);
            };

            this.comms.doFetch(endpoint, options, commander, innerCallback, errorCallback);
        }
    }

    //dejure
    public callDejure(ids: number[] = [], callback?: Function): void {
        let model: Model = Model.getReactiveInstance();
        let token: string = model.returnedToken; //"AQIC5wM2LY4SfcwohGWOA30RUQd7mHXhPtUXF3XcvqjHseI.*AAJTSQACMDEAAlNLABM4MTgyNTM1NDgxMDk4MDM3NDgyAAJTMQAA*";

        let urlDejureSave: string = frontendConfig.urlDejureSave; //"https://gflapi-pre.giuffre.it/api/ModuloStrategia";
        let databankDejureSave: number = frontendConfig.databankDejureSave; //2;
        let urlDejureOpen: string = frontendConfig.urlDejureOpen+token; // "https://dejure-pre.giuffre.it/#/home?moduloStrategia=true&ticket="+token;
        
        let that: CommsFamiglia = this;
        
        if (!this.inChiamataDejure && ids.length > 0) {
            this.inChiamataDejure = true;
            let options = {
                method: "POST",
                headers: {
                    accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    "Token": token,
                    "IdDatabank": databankDejureSave,
                    "IdDocMasterList": ids
                }),
            };
            
            fetch(urlDejureSave, options)
                .then((res: Response) => {
                    that.inChiamataDejure = false;
                    if (res.ok) {
                        return res.json();
                    } else {
                        if (callback) callback();
                        alert("ERRORE IN APERTURA DEJURE")
                    }
                })
                .then((response) => {
                    that.inChiamataDejure = false;
                    
                    if (response != undefined && response != null) {
                        // gtagO({event: 'outboundlink', url: urlDejureOpen})

                        window.open( urlDejureOpen, "_blank");
                    } else {
                        alert("ERRORE DI SALVATAGGIO SU DEJURE")
                    }
                    if (callback) callback();
                    //alla fine
                })
                .catch((err) => {
                    that.inChiamataDejure = false;
                    if (callback) callback();
                    alert("ERRORE IN CHIAMATA DEJURE")
                });
        } else {
            if (callback) callback();
        }
    }
    public openDettaglioDejure(id_doc_master: number = -1, id_databanks: number = -1, id: string = ""): void {
        let model: Model = Model.getReactiveInstance();
        let detailUrl: string = frontendConfig.urlDejureDetail.replace('{{id_doc_master}}', id_doc_master).replace('{{id}}', id).replace('{{id_databanks}}', id_databanks);
        detailUrl += model.returnedToken;
        
        // gtagO({event: 'outboundlink', url: detailUrl})

        window.open(detailUrl, "_blank");
    }
    public openDettaglioModal(id_doc_master: number = -1, id_databanks: number = -1, id: string = ""): void {
        let model: Model = Model.getReactiveInstance();
        model.testo_result = new TestoResult();
        model.testo_data = new TestoData();
        model.testo_data.id_doc_master = id_doc_master; //popolare altri parametri di model.testo_data ? tipo_testo = 2;   id_unita_doc =  0; tipo_ud = 0;

        //apre modale
        document.getElementById("triggerModalDettaglio")?.click();
        //chiamata
        this.queryGetTesto( () => {} );
    }

    //query testo dettaglio
    public queryGetTesto(callback: Function | null = null): void {
        if (Comms.hf_isNotLogged()) {
            this.continueFunction = this.queryGetTesto;

            setTimeout(function () {
                Comms.getInstance().doLoginByToken(callback);
            }, Comms.baseLoadTimeout);

            return;
        } else {
            this.continueFunction = null;
        }

        let model: Model = Model.getReactiveInstance();
        model.testo_result = new TestoResult();

        if (model.testo_data.id_doc_master) {
            let commander: string = "queryGetTesto";
            let endpoint: string = "/graphql";
            let innerParams: string = "";

            innerParams += 'id_doc_master:' + model.testo_data.id_doc_master + ' ';
            
            if (model.testo_data.tipo_testo)  {
                innerParams += 'tipo_testo:' + model.testo_data.tipo_testo + ' ';
            }
            if (model.testo_data.id_unita_doc)  {
                innerParams += 'id_unita_doc:' + model.testo_data.id_unita_doc + ' ';
            }
            if (model.testo_data.tipo_ud)  {
                innerParams += 'tipo_ud:' + model.testo_data.tipo_ud + ' ';
            }

            let params: string = `{ ${innerParams} }`;
            let payload = {
                query: `{
                  pgQuery(
                     input: {
                        name: "api_get_testo"
                        params: ${params}
                     }
                  ) {
                     list
                  }
               }`,
                variables: {},
                operationName: null,
            };

            let options = {
                method: "POST",
                headers: {
                    accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            };
            //@ts-ignore
            if (Comms.baseUrl == "") options.headers["x-user"] = model.user.jwt;

            let errorCallback: Function = (): void => { };

            let innerCallback: Function = (esito: IEsito): void => {
                Utils.successAlert(esito);

                model.testo_result = new TestoResult(esito.response);

                gtagO({ 'event': 'getTesto', 'testoCercato': JSON.stringify(payload)});

                if (callback) callback(esito);
            };
            
            this.comms.doFetch(endpoint, options, commander, innerCallback, errorCallback);
        }
    }

    //sintetizza
    public openSintesi(page: string, id: number, params: ISintesiParams): void {
        let urlSintesi: string = frontendConfig.urlSintesi.replace('{{idDocMaster}}', params.id_doc_master.toString()).replace('{{username}}', params.username).replace('{{crmid}}', params.crmid);
        //console.log("SINTETIZZO CON AI", page, id, params, urlSintesi);
        // Trova la riga di riferimento
        const referenceRow: HTMLElement | null = document.getElementById('docRiga-'+page+'-'+id);
        let newRowId: string = 'docRiga2-'+page+'-'+id;
        const referenceRow2: HTMLElement | null = document.getElementById(newRowId);
        if (!referenceRow2) {
            if (referenceRow) {
                const newRow = document.createElement('tr');
                newRow.id = newRowId;
                const newCell = document.createElement('td');
                newCell.colSpan = 3;
                newCell.classList.add("rigaSintetizza");
                newCell.innerHTML = `<div class="accordion" id="accordion-${page}-${id}">
                    <div class="accordion-item">
                        <h2 class="accordion-header">
                        <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-${page}-${id}" aria-expanded="true" aria-controls="collapse-${page}-${id}">
                            SINTESI
                        </button>
                        </h2>
                        <div id="collapse-${page}-${id}" class="accordion-collapse collapse show" data-bs-parent="#accordion-${page}-${id}">
                        <div class="accordion-body">
                            <iframe src="${urlSintesi}" class="iframeSintetizza"></iframe>
                        </div>
                        </div>
                    </div>
                    </div>`;


                // Aggiungi le celle alla nuova riga
                newRow.appendChild(newCell);

                // Inserisci la nuova riga subito dopo la riga di riferimento
                if (referenceRow.parentNode) {
                    referenceRow.parentNode.insertBefore(newRow, referenceRow.nextSibling);
                } else {
                    erroreFun()
                }

            } else {
                erroreFun()
            }
        }

        function erroreFun(): void {
            console.error(`Errore nella sintesi della riga ${id}`);
        }
    }
}

export interface IEsito {
    isOk: boolean;
    commander: string;
    response: any
}
export interface ISintesiParams {
    id_doc_master: number;
    username: string;
    crmid: string;
}